module.exports = __webpack_public_path__ + "static/media/afl-pro.e168612c.webp";